import styled from 'styled-components';
import { Card } from 'antd';

export const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
`;

export const LoginCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  padding: 40px 32px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: none;

  .ant-card-body {
    padding: 0;
  }
`;

export const Logo = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  text-align: center;
  color: #262626;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  text-align: center;
  color: #8c8c8c;
  margin: 0 0 32px 0;
  font-size: 14px;
`;